import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faGithub} from '@fortawesome/free-brands-svg-icons'
import {faHackerrank} from '@fortawesome/free-brands-svg-icons'
import {faLinkedin} from '@fortawesome/free-brands-svg-icons'
import Resume from '../Documents/Anurag_Singh_Tomar_Resume.pdf'



const HomePage = () => {
    return (
        <div className="HomePage">
            <header className="hero">
                <h1 className="hero-text">
                    Hi, I am
                    <span> Anurag Tomar. </span>
                </h1>
                
                <div className="h-sub-text-large">
                    a self-taught passionate Full-Stack Developer from India. I love to build beautiful and performant products with delightful user experience. I've been building stuff on the web for last three years. I've developed countless web applications starting from static ones to full-fledged social networking and eCommerce applications. It gives me an excitement and tremendous sense of accomplishment that i can't put into words. I also started sharing my learnings in the last six months by creating blogs on various platforms.
                </div>

                <div className="h-sub-text-small">
                    a self-taught passionate Full-Stack Developer from India.
                </div>

              
                <div className="icons"> 
                    <a href="https://github.com/anuragtomar2510" className="icon-holder" target="_blank">
                        <FontAwesomeIcon icon={faGithub} className="icon gh" />
                    </a>
                    <a href="https://www.hackerrank.com/anuragtomar2510" className="icon-holder" target="_blank">
                        <FontAwesomeIcon icon={faHackerrank} className="icon hk" />     
                    </a>
                    <a href="https://www.linkedin.com/in/anuragtomar25/" className="icon-holder" target="_blank">
                        <FontAwesomeIcon icon={faLinkedin} className="icon li" />     
                    </a>                    
                </div>

                <div className="download">
                    <button className="btn" onClick={() => window.open(Resume)}>Download Resume</button>
                </div>
            </header>
        </div>
    )
}

export default HomePage
